import type { ReceiptSource, ReceiptStatus } from "@/api/types";
import "./status-badge.css";

interface Mapping {
  label: string;
  klass: string;
}

// ADR-0021: the `uploaded` state is gone from the receipt lifecycle —
// `parse-worker` is triggered by the S3 event and transitions
// `pending_upload → parsing` itself; the SPA never observes a separate
// "uploaded" status.
const STATUS_MAP: Record<ReceiptStatus, Mapping> = {
  pending_upload: { label: "Завантаження…", klass: "wp-status--neutral" },
  parsing: { label: "Розпізнаю", klass: "wp-status--primary" },
  parsed: { label: "Перевір", klass: "wp-status--warning" },
  parse_failed: { label: "Помилка", klass: "wp-status--danger" },
  confirmed: { label: "Підтверджено", klass: "wp-status--success" },
};

export function ReceiptStatusBadge({
  status,
  source,
}: {
  status: ReceiptStatus;
  /**
   * ADR-0031 / US-20: when `manual`, the badge is the neutral «Вручну» pill
   * (pencil glyph) regardless of the underlying status — a manual receipt is
   * reflected by construction and never «потребує уваги» (AC-20.8), so it must
   * NOT borrow the warning/success photo-lifecycle language. This is a
   * frontend derivation from `source` (CD-1), not a `ReceiptStatus` value.
   */
  source?: ReceiptSource;
}) {
  if (source === "manual") {
    return (
      <span className="wp-status wp-status--neutral" data-status="manual">
        <span aria-hidden="true" className="wp-status__glyph">
          ✎
        </span>
        Вручну
      </span>
    );
  }
  const m = STATUS_MAP[status];
  return (
    <span className={`wp-status ${m.klass}`} data-status={status}>
      {m.label}
    </span>
  );
}
